import { render, staticRenderFns } from "./MNotificationsLayout.vue?vue&type=template&id=76983d25"
import script from "./MNotificationsLayout.vue?vue&type=script&lang=js"
export * from "./MNotificationsLayout.vue?vue&type=script&lang=js"
import style0 from "./MNotificationsLayout.vue?vue&type=style&index=0&id=76983d25&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports